import React from 'react';
import ReactDOM from 'react-dom/client';
import { setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import App from './App';
import './theme/global.css';
import './utils/i18n';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { App as CapApp } from '@capacitor/app';

/**
 * Required for the Ionic custom-elements build: `structure.css` ships
 * `html:not(.hydrated) body { display: none }` to avoid a flash of unstyled
 * content, and `setupIonicReact()` is what marks the document (`html.ion-ce`)
 * so the app becomes visible. Without this the whole UI stays hidden.
 */
setupIonicReact();

async function initNative(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await StatusBar.setStyle({ style: Style.Dark });
  } catch {
    /* status bar plugin is Android/iOS only */
  }
  try {
    // Hardware back button pops the webview history; fall back to exiting.
    CapApp.addListener('backButton', () => {
      if (window.history.length > 1) window.history.back();
    });
  } catch {
    /* listener registration is best-effort */
  }
}

void initNative();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <IonReactRouter>
      <App />
    </IonReactRouter>
  </React.StrictMode>
);

